import { autoinject, bindable, bindingMode, customElement, observable, inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { Router } from 'aurelia-router';
import { DataService } from 'DataAccessLayer/Services/DataService';

@customElement('sidebar-wrapper')
@autoinject
export class SidebarWrapper {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) searchText: string = null;

    protected authService: AuthService = null;
    protected ea: EventAggregator = null;
    protected router: Router = null;
    protected dataService: DataService = null;

    constructor(eventAggregator: EventAggregator, router: Router, dataService: DataService, authService: AuthService) {
        this.ea = eventAggregator;
        this.router = router;
        this.dataService = dataService;
        this.authService = authService;
    }

    async bind() {
    }

}